/**
 * A global namespace for aria-valuetext.
 */
const ariaValueText = 'aria-valuetext';
export default ariaValueText;
